import { useTranslation } from 'react-i18next';
import FileUploader from './FileUploader';
import { FieldsGrid } from './GridFileUploader';

export interface AttachmentsGridProps {
  /** Array dei campi stringa dell'entità che rappresentano i file scaricabili */
  fields: string[];
  /** L'oggetto entità corrente (es. contract, customer, ecc.) */
  entity: Record<string, any>;
  /** Il servizio backend associato all'entità per la gestione dei file */
  service: any;
  /** Chiave di traduzione base per le label (Default: 'entities.contract') */
  translationPrefix?: string;
}

export const AttachmentsGrid = ({
  fields,
  entity,
  service,
  translationPrefix
}: AttachmentsGridProps) => {
  const { t } = useTranslation();

  return (
    <FieldsGrid
      fields={fields}
      getTitle={(field) => t(`${translationPrefix}.${field}`)}
      renderField={(field) => (
        <FileUploader
          service={service}
          entityId={entity.id}
          attachmentName={field}
          filename={entity[field]}
        />
      )}
    />
  );
};
